module.exports = __webpack_public_path__ + "img/charter-1.588b71d.png";